const Orders = () => import('@/modules/orders/index.vue');

export default [
  {
    path: '/franquia/pedidos',
    name: 'orders',
    component: Orders,
    meta: {
      navbarTitle: 'Pedidos',
      isAvaliableInMenu: false,
      menuData: {
        title: 'Pedidos',
        id: 'ordersSidebar',
      },
      nameCity: true,
    },
  },
  {
    path: '/franquia/pedidos/historico',
    name: 'order-history',
    component: Orders,
    meta: {
      navbarTitle: 'Pedidos',
    },
  },
];
